import { units } from "../enums/index.js";

export default unit => {
  switch (unit) {
    case units.WEIGHT: return "kg";
    case units.DISTANCE: return "m";
    default: return "";
  }
};
